import Button from '@components/Button'
import { isExternalUrl } from 'shared/utils'
import featureToggles from 'shared/featureToggles'
import { SEARCH_MODE_HOURLY } from 'search/constants'
import { searchModeSelector } from 'map/selectors'
import { RateCurrency } from 'shared/price-utilities'

const BuyButton = ({ opngo, rate, externalSeasonTicketUrl, buyLabel, bookingUrl, reservationsEnabled, searchMode }) => {
    const isHourly = SEARCH_MODE_HOURLY === searchMode

    const buttonProps = () => {
        if (opngo) {
            return {
                href: `https://www.opngo.com${opngo}`,
                target: '_blank',
                iconRight: 'opngo',
                children: <T>{buyLabel}</T>,
                external: true,
            }
        }
        if (
            isHourly &&
            !featureToggles.caPurchaseFlow &&
            reservationsEnabled === true &&
            externalSeasonTicketUrl !== null
        ) {
            return {
                href: externalSeasonTicketUrl,
                target: '_blank',
                iconRight: 'external',
                children: <T>map.results.list.book.external</T>,
                external: true,
            }
        }
        if (externalSeasonTicketUrl) {
            return {
                href: externalSeasonTicketUrl,
                target: '_blank',
                iconRight: 'external',
                children: <T>map.results.list.book.external</T>,
                external: true,
            }
        }

        return {
            href: bookingUrl,
            external: isExternalUrl(bookingUrl),
            children: (
                <>
                    <T>{buyLabel}</T>
                    {rate && (
                        <span className="text-small">
                            <RateCurrency
                                value={rate.amount}
                                currency={rate.currency}
                                minimumFractionDigits={rate.fractionDigits}
                                maximumFractionDigits={rate.fractionDigits}
                            />
                        </span>
                    )}
                </>
            ),
        }
    }

    return <Button size="large" block {...buttonProps()} />
}

export default compose(
    connect(
        createStructuredSelector({
            searchMode: searchModeSelector,
        })
    )
)(BuyButton)
